import ComponentManager from '@/Management/ComponentManager';
import ViewFactory from '@/Factories/ViewFactory';
import HeaderViewModel from '@/ViewModels/Views/HeaderViewModel';
import HeaderView from '@/Views/HeaderView';

export default class HeaderViewFactory extends ViewFactory {

    /**
     * @override
     */
    public viewModel: HeaderViewModel;

    constructor(params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Header';
    }

    /**
     * @override
     */
    public getView(): JQuery {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel();
        }

        if (this.view == null) {
            this.view = this.createView(this.viewModel)
        }

        const tuple = this.view.getTuple();
        return tuple.view;
    }

    protected createViewModelParameter(): any {
        return {
            locator: 'header'
        };
    }

    public createViewModel(): HeaderViewModel {
        const headerViewModel = ComponentManager.getViewModel<typeof HeaderViewModel>('HeaderViewModel');
        
        return new headerViewModel(this.createViewModelParameter());
    }

    public createView(viewModel: HeaderViewModel): HeaderView {
        const headerView = ComponentManager.getView<typeof HeaderView>('HeaderView');
        return new headerView(viewModel, this.createRootElement('Header'));
    }
}

ComponentManager.setFactory('Header', HeaderViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');